<digital-platform-dynamic-content-wrapper
  *ngFor="let content of newContent"
  [config]="content"
  class="content-container"
></digital-platform-dynamic-content-wrapper>
